import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
import { useMemo } from 'react';
export const useOrganizationAttachmentPreferences = ({ reason, }) => {
    const { permissions, isLoaded } = useEffectivePermissions({ reason });
    return useMemo(() => ({
        disabledByOrganization: isLoaded && !permissions.has('org_files_attach_to_threads'),
    }), [isLoaded, permissions]);
};
//# sourceMappingURL=useOrganizationAttachmentPreferences.js.map